enum SinkType {
  CloudWatchLogSink = "CloudWatchLogSink",
  ConsoleLogSink = "ConsoleLogSink",
  TestLogSink = "TestLogSink",
}

export default SinkType;
